import Dropdown from "@shared/v2/Dropdown";
import IconButton from "@shared/v2/IconButton";
import TextInput from "@shared/v2/TextInput";
import { Mls, Option } from "../reducers/personalReducer/types";
import { XmarkSolidV6 } from "@shared/v2/Icomoon";
import { useDispatch } from "react-redux";
import { removeMls } from "../reducers/personalReducer/personalReducer";
import { useMlsOptions, usePersonalErrors } from "../reducers/personalReducer/selectors";
import { useEffect, useRef, useState } from "react";

const MlsRow = ({ mls, i }: { mls: Mls; i: number }) => {
  const ref = useRef(null);
  const [option, setOption] = useState<Option>(null);
  const dispatch = useDispatch();
  const mlsOptions = useMlsOptions();
  const errors = usePersonalErrors();

  useEffect(() => {
    setOption(mlsOptions.find((o) => String(o.value) === String(mls.mlsId)) || null);
  }, [mls.mlsId, mlsOptions]);

  return (
    <div
      key={mls.id || mls.tmpId}
      className={`tw-flex tw-flex-wrap tw-items-start tw-gap-[16px] ${mls._destroy ? "tw-hidden" : ""}`}
    >
      {mls.id && <input type="hidden" name={`usersMlsesAttributes[${i}].id`} value={mls.id} />}
      {mls._destroy && (
        <input type="hidden" name={`usersMlsesAttributes[${i}]._destroy`} value={mls._destroy && "1"} />
      )}
      <Dropdown
        // @ts-expect-error props
        containerClassName="tw-flex-1"
        options={mlsOptions}
        value={option}
        isSearchable
        menuShouldComeToFront
        name={`usersMlsesAttributes[${i}].mlsId`}
        onChange={(selectedOption: Option) => {
          setOption(selectedOption);
        }}
      />
      <TextInput
        ref={ref}
        // @ts-expect-error props
        containerClassName="tw-flex-1"
        defaultValue={mls.mlsAgentId}
        error={!(ref.current as HTMLInputElement)?.value && errors?.["users_mlses.mls_agent_id"]?.[0]}
        autoComplete="off"
        name={`usersMlsesAttributes[${i}].mlsAgentId`}
      />
      {/* @ts-expect-error props */}
      <IconButton
        className="tw-mt-[2px]"
        schema="transparent"
        onClick={() => {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-call
          dispatch(removeMls(mls));
        }}
      >
        <XmarkSolidV6 size="l" />
      </IconButton>
    </div>
  );
};

export default MlsRow;
